import { Card, CardActionArea, CardContent, Checkbox, Chip, Icon, Typography } from "@mui/material";
import { languages, supportedLanguages, getFlag } from "@/utils/supportedLanguages";
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

const LibraryCard = ({library, onClick, isSelected}) => {

    const languageCode = supportedLanguages[library.applicationLanguage.applicationLanguageId - 1];

    return(
        <Card
            onClick={() => !library.isDownloaded ? onClick(library) : undefined} 
            sx={{
                height: '100%',
                minHeight: '170px',

                '&:hover': {
                    cursor: 'pointer'
                },
            }}
        >
            <CardActionArea style={{height: '100%'}} disabled={library.isDownloaded}>
                <CardContent style={{height: '100%'}}>
                    <div style={{display: "flex", flexDirection: "column", justifyContent: "space-between", height: '100%'}}>
                        <div style={{display: "flex"}}>
                            <Icon style={{marginRight: 10, fontSize: 70}}>{library.icon}</Icon>
                            <div>
                                <Typography variant="h5" style={{display: 'flex', alignItems: 'center', fontSize: 24}}>{library.name}</Typography>
                                <Typography variant="body1" color="text.secondary" style={{fontSize: 14}}>{library.label}</Typography>
                            
                                <div style={{display: "flex", alignItems: 'center', marginTop: 10}}>
                                        <Chip 
                                            size="small" 
                                            label={`V ${library.version}`} 
                                        />
                                        {languageCode &&
                                            <img 
                                                style={{height: 12, width: 'auto', marginLeft: 10}}
                                                src={getFlag(40, languages[languageCode]?.countryCode)}
                                                alt={languages[languageCode]?.displayName}
                                            />
                                        }
                                </div>
                            </div>
                        </div>

                        <div style={{marginTop: 30, display: "flex", justifyContent: 'space-between', width: '100%', alignItems: 'flex-end'}}>
                            <div>
                            <Typography sx={{fontSize: '40px', fontWeight: 'bold', lineHeight: 1, color: library.applicationModule.color}}>
                                    {library.applicationModule.titleLabel}
                                </Typography>
                                <Typography sx={{fontSize: '20px', fontWeight: 'bold', lineHeight: 1 }}>
                                    LIBRARIES
                                </Typography>
                            </div>

                            { library.isDownloaded ? 
                                <CheckCircleIcon color="success" sx={{
                                    fontSize: '50px'
                                }} />
                            :    
                                <Checkbox 
                                    onClick={() => onClick(library)}
                                    checked={isSelected}
                                    sx={{ '& .MuiSvgIcon-root': { fontSize: 40 } }} 
                                />
                            }
                        </div>
                    </div>
                </CardContent>
            </CardActionArea>
        </Card>
    );
}

export default LibraryCard;